import { createApiHandler } from './handler';

const pets = {
  apiClient: null,
  path: '/admin/pets',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async saveProfilePicture(form) {
    try {
      const response = await this.apiClient.post(`${this.path}/save-profile-picture`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async reevaluate(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/reevaluate`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCheckups(id, params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/${id}/checkups?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCheckupById(id) {
    try {
      const response = await this.apiClient.get(`${this.path}/checkups/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createCheckup(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/checkups`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateCheckup(id, form) {
    try {
      const response = await this.apiClient.put(`${this.path}/checkups/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteCheckup(id) {
    try {
      const response = await this.apiClient.delete(`${this.path}/checkups/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createCheckupImage(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/checkups/${id}/image`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteCheckupImage(id) {
    try {
      const response = await this.apiClient.delete(`${this.path}/checkups/image/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createCheckupFile(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/checkups/${id}/file`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteCheckupFile(id) {
    try {
      const response = await this.apiClient.delete(`${this.path}/checkups/file/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};

export default pets;
